/* ============================================================
   K-home Design System - Interaktionen (vanilla JS, keine Deps)
   Header/Mega-Menü, Mobile-Nav, Suche, Cart-Drawer (AJAX),
   Mengen-Stepper, Tabs, Accordion, PDP-Varianten-Logik,
   Sticky-ATC, Kategorie-Filter (client-side), Cross-Selling.
   ============================================================ */
(function () {
  'use strict';

  var routes = window.KH_ROUTES || {
    cart_add_url: '/cart/add',
    cart_change_url: '/cart/change',
    cart_url: '/cart',
    root_url: '/',
  };

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatEuro(cents) {
    return (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' Euro';
  }

  /* ---------- Cart-Drawer ---------- */
  var Drawer = {
    el: null,
    init: function () {
      this.el = qs('#KhCartDrawer');
      if (!this.el) return;
      var self = this;
      document.addEventListener('click', function (e) {
        var opener = e.target.closest('[data-kh-open-cart]');
        if (opener) { e.preventDefault(); self.open(); return; }
        var closer = e.target.closest('[data-kh-close-cart]');
        if (closer && self.el.contains(closer)) { e.preventDefault(); self.close(); return; }
        if (e.target.classList && e.target.classList.contains('kh-drawer__overlay') && self.el.contains(e.target)) self.close();
        var removeBtn = e.target.closest('[data-kh-remove-line]');
        if (removeBtn) { e.preventDefault(); self.changeLine(parseInt(removeBtn.getAttribute('data-kh-remove-line'), 10), 0); }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.el.classList.contains('is-open')) self.close();
      });
    },
    open: function () {
      if (!this.el) return;
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    },
    close: function () {
      if (!this.el) return;
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    },
    replaceFromSectionHtml: function (html) {
      if (!this.el || !html) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var fresh = tmp.querySelector('#KhCartDrawer');
      if (!fresh) return;
      var wasOpen = this.el.classList.contains('is-open');
      var panelFresh = fresh.querySelector('.kh-drawer__panel');
      var panelOld = this.el.querySelector('.kh-drawer__panel');
      if (panelFresh && panelOld) {
        panelOld.innerHTML = panelFresh.innerHTML;
      } else {
        this.el.innerHTML = fresh.innerHTML;
      }
      if (wasOpen) this.open();
    },
    setBusy: function (busy) {
      if (this.el) this.el.setAttribute('aria-busy', busy ? 'true' : 'false');
    },
    changeLine: function (line, qty) {
      var self = this;
      self.setBusy(true);
      fetch(routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty, sections: 'kh-cart-drawer' }),
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          if (cart.sections && cart.sections['kh-cart-drawer']) self.replaceFromSectionHtml(cart.sections['kh-cart-drawer']);
        })
        .catch(function () { window.location.href = routes.cart_url; })
        .then(function () { self.setBusy(false); });
    },
  };

  function updateCartCount(count) {
    qsa('[data-kh-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', String(count));
    });
  }

  /* ---------- Bestandsgrenze der Mengenwahl ---------- */
  // Die Obergrenze ist der Lagerbestand minus dem, was von derselben Variante
  // schon im Warenkorb liegt. Ohne diesen Abzug ließe sich die Grenze umgehen,
  // indem man zweimal hintereinander die volle Menge einlegt. Shopify weist das
  // an der Kasse ohnehin ab, nur erfährt der Kunde es dann erst dort.
  var khWarenkorb = { zeilen: null };

  function ladeWarenkorbstand() {
    if (typeof fetch !== 'function') return Promise.resolve(null);
    return fetch(routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { khWarenkorb.zeilen = j ? (j.items || []) : null; return khWarenkorb.zeilen; })
      .catch(function () { return null; });
  }

  function mengeImWarenkorb(variantId) {
    if (!khWarenkorb.zeilen || !variantId) return 0;
    var n = 0;
    khWarenkorb.zeilen.forEach(function (z) {
      if (String(z.id) === String(variantId)) n += z.quantity;
    });
    return n;
  }

  // grund unterscheidet die beiden Fälle, die zu derselben Grenze führen:
  // 'lager' heisst, so viel ist einfach nicht da. 'warenkorb' heisst, der Rest
  // liegt bereits im Warenkorb. Für den Kunden ist das ein Unterschied.
  function zeigeMengenhinweis(box, max, grund, bestand) {
    var feld = box && box.closest('.kh-field');
    var hint = feld && feld.querySelector('[data-kh-qty-hint]');
    if (!hint) return;
    if (grund === 'warenkorb') {
      hint.textContent = bestand === 1
        ? 'Das eine verfügbare Stück liegt bereits in Ihrem Warenkorb.'
        : 'Alle ' + bestand + ' verfügbaren Stück liegen bereits in Ihrem Warenkorb.';
    } else {
      hint.textContent = max <= 0
        ? 'Diese Ausführung ist zurzeit nicht auf Lager.'
        : (max === 1
            ? 'Mehr als 1 Stück ist zurzeit nicht auf Lager.'
            : 'Mehr als ' + max + ' Stück sind zurzeit nicht auf Lager.');
    }
    hint.hidden = false;
    clearTimeout(hint._khTimer);
    hint._khTimer = setTimeout(function () { hint.hidden = true; }, 5000);
  }

  // Setzt den Wert einer Stepper-Box unter Beachtung von data-min und data-max
  // und hält die Knopfzustände nach. Rückgabe ist der wirklich gesetzte Wert.
  function stepperSetzen(box, wunsch, mitHinweis) {
    var input = box.querySelector('.kh-qty__value');
    if (!input) return null;
    var min = parseInt(input.getAttribute('data-min') || '1', 10);
    var max = parseInt(input.getAttribute('data-max') || '99', 10);
    if (isNaN(max)) max = 99;
    var wert = Math.max(min, Math.min(max, wunsch));
    if (mitHinweis && wunsch > max) {
      zeigeMengenhinweis(box, max, input.getAttribute('data-grund') || 'lager',
        parseInt(input.getAttribute('data-bestand') || '', 10));
    }
    if (input.tagName === 'INPUT') input.value = wert; else input.textContent = wert;
    box.querySelectorAll('.kh-qty__btn').forEach(function (b) {
      var isPlus = b.getAttribute('data-action') === 'plus';
      b.toggleAttribute('disabled', isPlus ? wert >= max : wert <= min);
    });
    return wert;
  }

  /* ---------- Add-to-Cart (alle Formulare mit data-kh-atc) ---------- */
  function initAtcForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[data-kh-atc]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.setAttribute('disabled', 'disabled'); btn.classList.add('kh-btn--busy'); }
      var fd = new FormData(form);
      fd.append('sections', 'kh-cart-drawer');
      fetch(routes.cart_add_url + '.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status && data.status !== 200) {
            // Shopify lehnt ab, wenn die Gesamtmenge den Bestand übersteigt.
            // Das sollte die Begrenzung am Mengenfeld vorher abfangen, hier
            // steht die Meldung an der Stelle, wo der Kunde gerade hinsieht.
            var qbox = form.querySelector('.kh-qty');
            var feld = qbox && qbox.closest('.kh-field');
            var hint = feld && feld.querySelector('[data-kh-qty-hint]');
            if (hint) {
              hint.textContent = data.description || 'Diese Menge ist zurzeit nicht auf Lager.';
              hint.hidden = false;
            }
            return ladeWarenkorbstand();
          }
          if (data.sections && data.sections['kh-cart-drawer']) Drawer.replaceFromSectionHtml(data.sections['kh-cart-drawer']);
          return fetch(routes.cart_url + '.js').then(function (r) { return r.json(); }).then(function (cart) {
            updateCartCount(cart.item_count);
            khWarenkorb.zeilen = cart.items || [];
            Drawer.open();
          });
        })
        .catch(function () { form.submit(); })
        .then(function () {
          if (btn) { btn.removeAttribute('disabled'); btn.classList.remove('kh-btn--busy'); }
          // Erst nach dem Freigeben melden, dass sich der Warenkorb geändert hat.
          // Sonst hebt die Freigabe oben eine Sperre wieder auf, die die
          // Bestandsgrenze gerade gesetzt hat.
          document.dispatchEvent(new CustomEvent('kh:warenkorb'));
        });
    });
  }

  /* ---------- Mengen-Stepper (Event-Delegation) ---------- */
  function initSteppers() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.kh-qty__btn');
      if (!btn) return;
      e.preventDefault();
      var box = btn.closest('.kh-qty');
      var input = box.querySelector('.kh-qty__value');
      var val = parseInt(input.value || input.textContent || '1', 10) || 1;
      var wunsch = btn.getAttribute('data-action') === 'plus' ? val + 1 : val - 1;
      var next = stepperSetzen(box, wunsch, true);
      if (next === null || next === val) return;
      var line = box.getAttribute('data-kh-line');
      if (line) Drawer.changeLine(parseInt(line, 10), next);
      var evt = new CustomEvent('kh:qty', { bubbles: true, detail: { value: next } });
      box.dispatchEvent(evt);
    });

    // Getippte Mengen begrenzen. Das Feld ist ein Textfeld, ohne diesen Zweig
    // ließe sich die Grenze mit der Tastatur übergehen.
    document.addEventListener('change', function (e) {
      var input = e.target.closest('input.kh-qty__value');
      if (!input) return;
      var box = input.closest('.kh-qty');
      if (!box) return;
      var roh = parseInt(String(input.value).replace(/[^0-9]/g, ''), 10);
      if (isNaN(roh) || roh < 1) roh = 1;
      var next = stepperSetzen(box, roh, true);
      if (next === null) return;
      var evt = new CustomEvent('kh:qty', { bubbles: true, detail: { value: next } });
      box.dispatchEvent(evt);
    });
  }

  /* ---------- Header: Mega-Menü, Mobile-Nav, Suche ---------- */
  function initHeader() {
    qsa('.kh-nav__item--mega').forEach(function (item) {
      var timer = null;
      item.addEventListener('mouseenter', function () {
        clearTimeout(timer);
        qsa('.kh-nav__item--mega.is-open').forEach(function (o) { if (o !== item) o.classList.remove('is-open'); });
        item.classList.add('is-open');
      });
      item.addEventListener('mouseleave', function () {
        timer = setTimeout(function () { item.classList.remove('is-open'); }, 120);
      });
      var trigger = item.querySelector('.kh-nav__link');
      if (trigger) {
        trigger.addEventListener('focus', function () { item.classList.add('is-open'); });
      }
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) item.classList.remove('is-open');
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') qsa('.kh-nav__item--mega.is-open').forEach(function (o) { o.classList.remove('is-open'); });
    });

    var mnav = qs('#KhMobileNav');
    if (mnav) {
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-kh-open-menu]')) { e.preventDefault(); mnav.classList.add('is-open'); mnav.setAttribute('aria-hidden', 'false'); mnav.removeAttribute('inert'); document.documentElement.style.overflow = 'hidden'; }
        if (e.target.closest('[data-kh-close-menu]') || (e.target.classList && e.target.classList.contains('kh-mnav__overlay'))) {
          mnav.classList.remove('is-open'); mnav.setAttribute('aria-hidden', 'true'); mnav.setAttribute('inert', ''); document.documentElement.style.overflow = '';
        }
        var subBtn = e.target.closest('[data-kh-subtoggle]');
        if (subBtn) {
          e.preventDefault();
          var sub = subBtn.parentElement.querySelector('.kh-mnav__sub');
          if (sub) sub.classList.toggle('is-open');
          var chev = subBtn.querySelector('.kh-icon');
          if (chev) chev.style.transform = sub && sub.classList.contains('is-open') ? 'rotate(180deg)' : '';
        }
      });
    }

    var search = qs('#KhSearch');
    if (search) {
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-kh-toggle-search]')) {
          e.preventDefault();
          search.classList.toggle('is-open');
          if (search.classList.contains('is-open')) {
            var inp = search.querySelector('input[type="search"]');
            if (inp) inp.focus();
          }
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') search.classList.remove('is-open');
      });
    }
  }

  /* ---------- Tabs ---------- */
  function initTabs() {
    qsa('[data-kh-tabs]').forEach(function (wrap) {
      var tabs = qsa('.kh-tab', wrap);
      var panels = qsa('.kh-tabs__panel', wrap);
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
          panels.forEach(function (p) {
            if (p.id === tab.getAttribute('aria-controls')) p.removeAttribute('hidden');
            else p.setAttribute('hidden', '');
          });
        });
      });
    });
    if (window.location.hash === '#reviews') {
      var revTab = qs('.kh-tab[data-tab-id="reviews"]');
      if (revTab) revTab.click();
    }
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href$="#reviews"]');
      if (!link) return;
      var revTab2 = qs('.kh-tab[data-tab-id="reviews"]');
      if (revTab2) {
        e.preventDefault();
        revTab2.click();
        var wrap = revTab2.closest('[data-kh-tabs]');
        if (wrap) wrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  /* ---------- Accordion ---------- */
  function initAccordions() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.kh-acc__btn');
      if (!btn) return;
      var item = btn.closest('.kh-acc__item');
      var acc = btn.closest('.kh-acc');
      var multiple = acc.hasAttribute('data-multiple');
      var wasOpen = item.classList.contains('is-open');
      if (!multiple) qsa('.kh-acc__item.is-open', acc).forEach(function (i) { i.classList.remove('is-open'); i.querySelector('.kh-acc__btn').setAttribute('aria-expanded', 'false'); });
      item.classList.toggle('is-open', !wasOpen);
      btn.setAttribute('aria-expanded', String(!wasOpen));
    });
  }

  /* ---------- PDP: Varianten, Galerie, Sticky-ATC ---------- */
  function initPdp() {
    var root = qs('[data-kh-pdp]');
    if (!root) return;
    var dataEl = qs('#KhProductData');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var colorOptIndex = parseInt(root.getAttribute('data-color-index') || '-1', 10);
    var sizeOptIndex = parseInt(root.getAttribute('data-size-index') || '-1', 10);
    var swatchWrap = qs('[data-kh-swatches]', root);
    var swatchLabel = qs('[data-kh-swatch-label]', root);
    var sizeSelect = qs('[data-kh-size]', root);
    var idInput = qs('input[name="id"]', root);
    var priceEl = qs('[data-kh-pdp-price]', root);
    var stockEl = qs('[data-kh-stock]', root);
    var atcBtns = qsa('[data-kh-pdp-atc]');
    var mainImg = qs('[data-kh-gallery-main] img', root);
    var galleryBlocks = { desktop: qs('.kh-gallery__thumbs', root), mobile: qs('.kh-gallery__mthumbs', root) };
    var satc = qs('#KhStickyAtc');

    function getColor() {
      var active = swatchWrap ? qs('.kh-swatch[aria-pressed="true"]', swatchWrap) : null;
      return active ? active.getAttribute('data-value') : null;
    }
    function getSize() { return sizeSelect ? sizeSelect.value : null; }

    function variantFor(color, size) {
      return variants.find(function (v) {
        var okC = colorOptIndex < 0 || v.options[colorOptIndex] === color;
        var okS = sizeOptIndex < 0 || v.options[sizeOptIndex] === size;
        return okC && okS;
      });
    }
    function colorAvailable(color, size) {
      return variants.some(function (v) {
        return v.available && (colorOptIndex < 0 || v.options[colorOptIndex] === color) && (sizeOptIndex < 0 || v.options[sizeOptIndex] === size);
      });
    }
    function buildColorThumbs(color) {
      if (!color || !mainImg) return;
      var galEl = document.getElementById('KhColorGallery');
      if (!window.__khGal) {
        try { window.__khGal = (JSON.parse(galEl ? galEl.textContent : '[]') || []).filter(Boolean); } catch (e) { window.__khGal = []; }
      }
      var items = window.__khGal.filter(function (g) { return g.c === color; });
      items.sort(function (a, b) { return (b.h ? 1 : 0) - (a.h ? 1 : 0); });
      var vimg = imageForColor(color);
      var hero = items[0] && items[0].h ? items[0] : null;
      var main = hero ? hero.u : (vimg || (items[0] ? items[0].u : null));
      if (!main) return;
      mainImg.src = main;
      mainImg.srcset = '';
      try { var khT = document.querySelector('.kh-buybox__title'); if (khT) mainImg.alt = khT.textContent.trim() + ' in ' + color; } catch (e) {}
      var list = [];
      function thumbOf(u) { return u ? u.replace('width=1400', 'width=140').replace('width=1200', 'width=140') : u; }
      function push(u, t) {
        if (!u) return;
        var key = u.split('?')[0].split('/').pop();
        if (list.some(function (x) { return x.k === key; })) return;
        list.push({ k: key, u: u, t: t || thumbOf(u) });
      }
      push(main, hero ? hero.t : null);
      push(vimg, null);
      items.forEach(function (g) { push(g.u, g.t); });
      list = list.slice(0, 5);
      ['desktop', 'mobile'].forEach(function (key) {
        var blockEl = galleryBlocks[key];
        if (!blockEl) return;
        qsa('.kh-gallery__thumb', blockEl).forEach(function (t) { t.remove(); });
        list.forEach(function (g, idx) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'kh-gallery__thumb' + (idx === 0 ? ' is-active' : '');
          b.setAttribute('aria-label', 'Produktbild ' + color + ' ' + (idx + 1));
          var im = document.createElement('img');
          im.src = g.t;
          im.setAttribute('data-full', g.u);
          im.loading = 'lazy';
          im.alt = (function () { try { var t = document.querySelector('.kh-buybox__title'); return (t ? t.textContent.trim() : '') + ' in ' + color + ', Bild ' + (idx + 1); } catch (e) { return ''; } })();
          b.appendChild(im);
          blockEl.appendChild(b);
        });
      });
    }

    function imageForColor(color) {
      var withImg = variants.find(function (v) { return v.options[colorOptIndex] === color && v.image; });
      return withImg ? withImg.image : null;
    }

    function prettySize(val) {
      var m = /^(\d+(?:[.,]\d+)?)x(\d+(?:[.,]\d+)?)cm$/i.exec(val || '');
      if (!m) return val ? val.replace('x', ' x ').replace('cm', ' cm').replace(/\s+/g, ' ').trim() : val;
      return m[1] + ' x ' + m[2] + ' cm';
    }

    function sortSizeOptions() {
      if (!sizeSelect) return;
      var parsed = qsa('option', sizeSelect).map(function (o) {
        var m = /^(\d+(?:[.,]\d+)?)x(\d+(?:[.,]\d+)?)cm$/i.exec(o.value);
        return { el: o, h: m ? parseFloat(m[1].replace(',', '.')) : 1e9, b: m ? parseFloat(m[2].replace(',', '.')) : 1e9 };
      });
      parsed.sort(function (a, b) { return a.h - b.h || a.b - b.b; });
      parsed.forEach(function (p) { p.el.textContent = prettySize(p.el.value); sizeSelect.appendChild(p.el); });
    }

    function refreshSizes() {
      if (!sizeSelect || sizeOptIndex < 0) return;
      var color = getColor();
      var existing = {};
      variants.forEach(function (v) {
        if (colorOptIndex < 0 || v.options[colorOptIndex] === color) existing[v.options[sizeOptIndex]] = true;
      });
      var current = sizeSelect.value;
      var currentGone = false;
      qsa('option', sizeSelect).forEach(function (o) {
        var ok = !!existing[o.value];
        o.hidden = !ok;
        o.disabled = !ok;
        if (!ok && o.value === current) currentGone = true;
      });
      if (currentGone) {
        var firstOk = qsa('option', sizeSelect).find(function (o) { return !o.disabled; });
        if (firstOk) sizeSelect.value = firstOk.value;
      }
    }

    function refreshSwatches() {
      if (!swatchWrap || colorOptIndex < 0) return;
      var size = getSize();
      var current = getColor();
      var currentOff = false;
      qsa('.kh-swatch', swatchWrap).forEach(function (sw) {
        var val = sw.getAttribute('data-value');
        var ok = colorAvailable(val, size);
        sw.classList.toggle('kh-swatch--off', !ok);
        sw.toggleAttribute('disabled', !ok);
        sw.setAttribute('title', ok ? val : val + ' (in dieser Größe nicht lieferbar)');
        if (!ok && val === current) currentOff = true;
      });
      if (currentOff) {
        var firstOk = qsa('.kh-swatch', swatchWrap).find(function (sw) { return !sw.classList.contains('kh-swatch--off'); });
        if (firstOk) selectColor(firstOk, true);
      }
    }

    function selectColor(swatchEl, silent) {
      qsa('.kh-swatch', swatchWrap).forEach(function (s) { s.setAttribute('aria-pressed', s === swatchEl ? 'true' : 'false'); });
      var color = swatchEl.getAttribute('data-value');
      if (swatchLabel) swatchLabel.textContent = color;
      refreshSizes();
      buildColorThumbs(color);
      if (!silent) update();
    }

    function setActiveThumb(idx) {
      ['desktop', 'mobile'].forEach(function (key) {
        var blockEl = galleryBlocks[key];
        if (!blockEl) return;
        qsa('.kh-gallery__thumb', blockEl).forEach(function (t, i) {
          t.classList.toggle('is-active', i === idx);
        });
      });
    }

    document.addEventListener('click', function (e) {
      var thumb = e.target.closest('.kh-gallery__thumb');
      if (thumb && root.contains(thumb)) {
        var img = thumb.querySelector('img');
        if (img && mainImg) {
          mainImg.src = img.getAttribute('data-full') || img.src;
          mainImg.srcset = '';
        }
        var blockEl = thumb.parentElement;
        var idx = qsa('.kh-gallery__thumb', blockEl).indexOf(thumb);
        setActiveThumb(idx);
      }
      var sw = e.target.closest('.kh-swatch');
      if (sw && swatchWrap && swatchWrap.contains(sw) && !sw.hasAttribute('disabled')) {
        selectColor(sw, false);
      }
    });

    if (sizeSelect) {
      sizeSelect.addEventListener('change', function () {
        refreshSwatches();
        update();
      });
    }

    buildColorThumbs(getColor());

    // Lagerzeile. Zwei Stufen: sofort aus der Variantenmatrix, damit beim Umschalten
    // nichts stehenbleibt, danach der echte Bestand aus der Section kh-lagerstand.
    // Die Matrix ist ein nächtlicher Abzug, die Zahl darf nicht aus ihr stammen,
    // wenn jemand danach entscheidet, ob er mehrere Stück bestellen kann.
    var lagerSektion = null;
    var lagerLauf = 0;
    var lagerAbbruch = null;
    var lagerTimer = null;

    function sektionId() {
      if (lagerSektion !== null) return lagerSektion;
      var el = document.querySelector('[data-kh-lagerstand]');
      var wrap = el && el.closest('.shopify-section');
      lagerSektion = wrap ? wrap.id.replace(/^shopify-section-/, '') : '';
      return lagerSektion;
    }

    // Obergrenze der Mengenwahl auf den Bestand setzen, abzüglich dessen, was
    // von dieser Variante schon im Warenkorb liegt. Ohne Bestandsverfolgung
    // bleibt es bei 99. Der Wert aus der Variantenmatrix ist ein Abzug und kann
    // veraltet sein, deshalb überschreibt ihn kurz darauf der Live-Wert aus
    // der nachgeladenen Lagerzeile.
    function setzeMengengrenze(menge, tracked) {
      var box = qs('.kh-qty', root);
      var input = box && box.querySelector('.kh-qty__value');
      if (!box || !input) return;
      var grenze = 99;
      var drin = 0;
      if (tracked && typeof menge === 'number' && !isNaN(menge)) {
        drin = mengeImWarenkorb(idInput && idInput.value);
        grenze = Math.max(0, menge - drin);
      }
      input.setAttribute('data-max', String(grenze));
      input.setAttribute('data-grund', drin > 0 ? 'warenkorb' : 'lager');
      input.setAttribute('data-bestand', tracked && typeof menge === 'number' ? String(menge) : '');
      var val = parseInt(input.value, 10) || 1;
      stepperSetzen(box, Math.min(val, Math.max(1, grenze)), false);
      if (grenze <= 0) {
        atcBtns.forEach(function (b) { b.setAttribute('disabled', 'disabled'); });
        zeigeMengenhinweis(box, 0, drin > 0 ? 'warenkorb' : 'lager', menge);
      }
    }

    function grenzeAusLagerzeile(el) {
      if (!el) return;
      var roh = el.getAttribute('data-qty');
      var tracked = el.getAttribute('data-tracked') === '1' && roh !== null && roh !== '';
      setzeMengengrenze(tracked ? parseInt(roh, 10) : null, tracked);
    }

    function setStock(v, available) {
      if (!stockEl) return;
      setzeMengengrenze(v && typeof v.qty === 'number' ? v.qty : null, !!(v && typeof v.qty === 'number'));
      if (!available) {
        stockEl.className = 'kh-stock kh-stock--off';
        stockEl.innerHTML = stockEl.getAttribute('data-msg-off') || '';
        return;
      }
      var thr = parseInt(stockEl.getAttribute('data-low-threshold'), 10);
      var q = (v && typeof v.qty === 'number') ? v.qty : null;
      if (thr > 0 && q !== null && q > 0 && q <= thr) {
        stockEl.className = 'kh-stock kh-stock--low';
        stockEl.innerHTML = q === 1
          ? (stockEl.getAttribute('data-msg-one') || '')
          : (stockEl.getAttribute('data-msg-low') || '').replace('{menge}', q);
        return;
      }
      stockEl.className = 'kh-stock';
      stockEl.innerHTML = stockEl.getAttribute('data-msg-ok') || '';
    }

    function ladeLagerstand(v) {
      if (!stockEl || !v || !v.id) return;
      var sid = sektionId();
      if (!sid || typeof fetch !== 'function') return;
      if (lagerTimer) clearTimeout(lagerTimer);
      lagerTimer = setTimeout(function () {
        if (lagerAbbruch) { try { lagerAbbruch.abort(); } catch (e) {} }
        lagerAbbruch = (typeof AbortController === 'function') ? new AbortController() : null;
        var lauf = ++lagerLauf;
        var url = location.pathname + '?variant=' + encodeURIComponent(v.id) +
                  '&section_id=' + encodeURIComponent(sid);
        fetch(url, lagerAbbruch ? { signal: lagerAbbruch.signal } : undefined)
          .then(function (r) { return r.ok ? r.text() : null; })
          .then(function (html) {
            // Nur übernehmen, wenn inzwischen keine neuere Auswahl kam.
            if (!html || lauf !== lagerLauf || !stockEl) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var frisch = doc.querySelector('[data-kh-stock]');
            if (!frisch) return;
            stockEl.className = frisch.className;
            stockEl.innerHTML = frisch.innerHTML;
            stockEl.setAttribute('data-qty', frisch.getAttribute('data-qty') || '');
            stockEl.setAttribute('data-tracked', frisch.getAttribute('data-tracked') || '0');
            grenzeAusLagerzeile(frisch);
          })
          .catch(function () { /* Netz weg oder abgebrochen: die Sofortanzeige bleibt stehen */ });
      }, 180);
    }

    function update() {
      var v = variantFor(getColor(), getSize());
      var available = !!(v && v.available);
      if (v && idInput) idInput.value = v.id;
      if (v && priceEl) {
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        priceEl.classList.toggle('kh-price--sale', !!onSale);
        var valEl = priceEl.querySelector('.kh-price__value');
        if (valEl) valEl.textContent = formatEuro(v.price);
        var cmpEl = priceEl.querySelector('.kh-price__compare');
        if (cmpEl) {
          cmpEl.textContent = onSale ? formatEuro(v.compare_at_price) : '';
          cmpEl.style.display = onSale ? '' : 'none';
        }
        var fromEl = priceEl.querySelector('.kh-price__from');
        if (fromEl) fromEl.style.display = 'none';
      }
      var inlineWrap = qs('[data-kh-inline-price]', root);
      if (inlineWrap && v) {
        var ivp = inlineWrap.querySelector('.kh-price__value');
        if (ivp) ivp.textContent = formatEuro(v.price);
      }
      if (stockEl) {
        setStock(v, available);
        ladeLagerstand(v);
      }
      atcBtns.forEach(function (b) { b.toggleAttribute('disabled', !available); });
      if (satc) {
        var variantLabel = qs('[data-kh-satc-variant]', satc);
        var color = getColor();
        var size = getSize();
        var sizePretty = prettySize(size);
        if (variantLabel) variantLabel.textContent = [color, sizePretty].filter(Boolean).join(' · ');
        var satcName = qs('[data-kh-satc-name]', satc);
        if (satcName && color) satcName.textContent = satcName.getAttribute('data-base') + ' · ' + color;
        var satcImg = qs('.kh-satc__img', satc);
        var ci = imageForColor(color);
        if (satcImg && ci) satcImg.src = ci;
        var satcPrices = qsa('[data-kh-satc-price]', satc);
        satcPrices.forEach(function (p) {
          var vp = p.querySelector('.kh-price__value');
          if (vp && v) vp.textContent = formatEuro(v.price);
          var fr = p.querySelector('.kh-price__from');
          if (fr) fr.style.display = 'none';
        });
      }
      var evt = new CustomEvent('kh:variant', { bubbles: true, detail: { variant: v } });
      root.dispatchEvent(evt);
    }

    var qtyBox = qs('.kh-qty', root);
    var qtyHidden = qsa('input[name="quantity"]');
    if (qtyBox) {
      qtyBox.addEventListener('kh:qty', function (e) {
        qtyHidden.forEach(function (i) { i.value = e.detail.value; });
      });
    }

    // Beim Seitenaufruf einmal den Warenkorb lesen, damit die Grenze auch dann
    // stimmt, wenn von dieser Variante schon etwas drin liegt. Danach nach
    // jedem Hinzufügen neu rechnen.
    ladeWarenkorbstand().then(function () { grenzeAusLagerzeile(stockEl); });
    document.addEventListener('kh:warenkorb', function () { grenzeAusLagerzeile(stockEl); });

    if (satc && window.matchMedia('(min-width: 750px)').matches) {
      var onScroll = function () {
        satc.classList.toggle('is-visible', window.scrollY > 620);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    } else if (satc) {
      satc.classList.add('is-visible');
    }

    var massIn = qs('[data-kh-mass]', root);
    if (massIn) {
      var mirrors = qsa('[data-kh-mass-mirror]');
      massIn.addEventListener('input', function () {
        mirrors.forEach(function (m) { m.value = massIn.value; });
      });
      mirrors.forEach(function (m) {
        var mf = m.closest('form');
        if (mf) mf.addEventListener('submit', function (e) {
          if (!massIn.value.trim()) {
            e.preventDefault();
            massIn.focus();
            massIn.scrollIntoView({ block: 'center', behavior: 'smooth' });
          }
        });
      });
    }

    sortSizeOptions();
    refreshSizes();
    refreshSwatches();
    update();
  }

  /* ---------- Kategorie: Client-side Filter + Sortierung ---------- */
  function initCollection() {
    var root = qs('[data-kh-collection]');
    if (!root) return;
    var grid = qs('[data-kh-grid]', root);
    var cards = qsa('[data-kh-item]', grid);
    var countEl = qs('[data-kh-count]', root);
    var chipsWrap = qs('[data-kh-chips]', root);
    var emptyEl = qs('[data-kh-empty]', root);
    var totalCount = cards.length;

    var state = { types: [], colors: [], sizes: [], heights: [], price: null };
    var PRICE_BUCKETS = { 'p0-15': [0, 1500], 'p15-30': [1500, 3000], 'p30-': [3000, 99999900] };
    // Breiten-Buckets werden unten aus den echten Kartenwerten gebaut.
    // Schluessel-Format: s<von>-<bis>, offenes Ende als s<von>-
    function parseSizeBucket(key) {
      var m = /^s(\d+)-(\d*)$/.exec(key || '');
      if (!m) return [0, 9999];
      return [parseInt(m[1], 10), m[2] ? parseInt(m[2], 10) : 9999];
    }

    function matches(card, s) {
      s = s || state;
      if (s.types.length) {
        var t = card.getAttribute('data-type') || '';
        if (s.types.indexOf(t) === -1) return false;
      }
      if (s.colors.length) {
        var cols = (card.getAttribute('data-colors') || '').split('||');
        var hit = s.colors.some(function (c) { return cols.indexOf(c) !== -1; });
        if (!hit) return false;
      }
      if (s.sizes.length) {
        var widths = (card.getAttribute('data-widths') || '').split(',').map(Number).filter(Boolean);
        var hitS = s.sizes.some(function (key) {
          var b = parseSizeBucket(key);
          return widths.some(function (w) { return w >= b[0] && w < b[1]; });
        });
        if (!hitS) return false;
      }
      if (s.heights.length) {
        var hs = (card.getAttribute('data-heights') || '').split(',').map(Number).filter(Boolean);
        var hitH = s.heights.some(function (h) { return hs.indexOf(+h) !== -1; });
        if (!hitH) return false;
      }
      if (s.price) {
        var p = parseInt(card.getAttribute('data-price') || '0', 10);
        var pb = PRICE_BUCKETS[s.price];
        if (!(p >= pb[0] && p < pb[1])) return false;
      }
      return true;
    }



    function sortColorSwatches() {
      // Logische Farb-Reihenfolge: Neutrale hell -> dunkel, dann Buntfarben entlang des Farbkreises.
      qsa('.kh-fcolors').forEach(function (wrap) {
        var btns = qsa('.kh-fcolor', wrap);
        if (btns.length < 3) { wrap.removeAttribute('data-kh-unsorted'); return; }
        function hslOf(btn) {
          var m = (getComputedStyle(btn).backgroundColor || '').match(/\d+(\.\d+)?/g);
          if (!m || m.length < 3) return [0, 0, 1];
          var r = m[0] / 255, g = m[1] / 255, b = m[2] / 255;
          var max = Math.max(r, g, b), min = Math.min(r, g, b);
          var l = (max + min) / 2, d = max - min;
          var s = d === 0 ? 0 : d / (1 - Math.abs(2 * l - 1));
          var h = 0;
          if (d) {
            if (max === r) h = ((g - b) / d + 6) % 6;
            else if (max === g) h = (b - r) / d + 2;
            else h = (r - g) / d + 4;
            h = h * 60;
          }
          return [h, s, l];
        }
        btns.map(function (b) {
          var x = hslOf(b);
          var neutral = x[1] < 0.10;
          // Neutrale zuerst (hell -> dunkel), dann Bunt ab den Erdtoenen entlang des Farbkreises, je Ton hell -> dunkel
          var key = neutral ? [0, 1 - x[2], 0] : [1, ((x[0] - 20 + 360) % 360) / 360, 1 - x[2]];
          return { b: b, k: key };
        }).sort(function (a, b) {
          for (var i = 0; i < 3; i++) { if (a.k[i] !== b.k[i]) return a.k[i] - b.k[i]; }
          return 0;
        }).forEach(function (item) { wrap.appendChild(item.b); });
        wrap.removeAttribute('data-kh-unsorted');
      });
    }

    function countWith(s) {
      var n = 0;
      cards.forEach(function (card) { if (matches(card, s)) n++; });
      return n;
    }

    function cloneState() {
      return { types: state.types.slice(), colors: state.colors.slice(), sizes: state.sizes.slice(), heights: state.heights.slice(), price: state.price };
    }

    function updateAvailability() {
      // Option ausgrauen, wenn sie als einzige Wahl ihrer Gruppe (bei sonst gleicher Auswahl) 0 Treffer ergibt.
      function probe(kind, value) {
        var s = cloneState();
        if (kind === 'price') { s.price = value; } else { s[kind + 's'] = [value]; }
        return countWith(s) > 0;
      }
      function setDis(el, disabled, isActive) {
        var off = disabled && !isActive;
        el.classList.toggle('is-disabled', off);
        if (el.tagName === 'BUTTON') el.disabled = off;
        if (el.tagName === 'INPUT') el.disabled = off;
      }
      qsa('[data-kh-ftype]', document).forEach(function (input) {
        setDis(input, !probe('type', input.value), state.types.indexOf(input.value) !== -1);
        var lbl = input.closest('label'); if (lbl) lbl.classList.toggle('is-disabled', input.disabled);
      });
      qsa('[data-kh-fcolor]', document).forEach(function (btn) {
        var v = btn.getAttribute('data-value');
        setDis(btn, !probe('color', v), state.colors.indexOf(v) !== -1);
      });
      qsa('[data-kh-fsize]', document).forEach(function (btn) {
        var v = btn.getAttribute('data-value');
        setDis(btn, !probe('size', v), state.sizes.indexOf(v) !== -1);
      });
      qsa('[data-kh-fheight]', document).forEach(function (btn) {
        var v = btn.getAttribute('data-value');
        setDis(btn, !probe('height', v), state.heights.indexOf(v) !== -1);
      });
      qsa('[data-kh-fprice]', document).forEach(function (input) {
        if (input.value === '') return;
        setDis(input, !probe('price', input.value), state.price === input.value);
        var lbl = input.closest('label'); if (lbl) lbl.classList.toggle('is-disabled', input.disabled);
      });
    }

    function labelFor(kind, value) {
      if (kind === 'price') {
        return { 'p0-15': 'bis 15 Euro', 'p15-30': '15 bis 30 Euro', 'p30-': 'ab 30 Euro' }[value] || value;
      }
      if (kind === 'size') {
        var sb = document.querySelector('[data-kh-fsize][data-value="' + value + '"]');
        return sb ? sb.textContent.trim() : value;
      }
      return value;
    }


    function cardMapOf(card) {
      if (card.__khMap !== undefined) return card.__khMap;
      var s = card.querySelector('[data-kh-cardmap]');
      try { card.__khMap = s ? JSON.parse(s.textContent) : null; } catch (e) { card.__khMap = null; }
      return card.__khMap;
    }

    function updateCardPreviews() {
      var hasColor = state.colors.length > 0;
      var hasHeights = state.heights.length > 0;
      var hasWidths = state.sizes.length > 0;
      var active = hasColor || hasHeights || hasWidths;
      var heightNums = state.heights.map(Number);
      cards.forEach(function (card) {
        var a = card.querySelector('a.kh-card');
        var img = card.querySelector('.kh-card__media img');
        var priceEl = card.querySelector('.kh-card__foot .kh-price__value');
        if (!a) return;
        if (!card.__khOrig) {
          card.__khOrig = {
            href: a.getAttribute('href'),
            src: img ? img.getAttribute('src') : null,
            srcset: img ? img.getAttribute('srcset') : null,
            price: priceEl ? priceEl.textContent : null
          };
        }
        function reset() {
          var o = card.__khOrig;
          if (a.getAttribute('href') !== o.href) a.setAttribute('href', o.href);
          if (img && o.src && img.getAttribute('src') !== o.src) {
            img.src = o.src;
            if (o.srcset) img.setAttribute('srcset', o.srcset);
          }
          if (priceEl && o.price !== null && priceEl.textContent !== o.price) priceEl.textContent = o.price;
        }
        var map = cardMapOf(card);
        if (!active || !map || card.classList.contains('kh-product-hidden')) { reset(); return; }

        var chosenColor = null;
        if (hasColor && map.c) {
          for (var i = 0; i < state.colors.length; i++) {
            if (map.c[state.colors[i]]) { chosenColor = state.colors[i]; break; }
          }
        }
        var sizeMin = null, sizeVid = null;
        if ((hasHeights || hasWidths) && map.s) {
          Object.keys(map.s).forEach(function (key) {
            var m = /^(\d+(?:[.,]\d+)?)x(\d+(?:[.,]\d+)?)cm$/.exec(key);
            if (!m) return;
            var h = parseFloat(m[1].replace(',', '.'));
            var w = parseFloat(m[2].replace(',', '.'));
            if (hasHeights && heightNums.indexOf(h) === -1) return;
            if (hasWidths) {
              var okW = state.sizes.some(function (k) { var b = SIZE_BUCKETS[k]; return b && w >= b[0] && w < b[1]; });
              if (!okW) return;
            }
            var e = map.s[key];
            if (sizeMin === null || e[0] < sizeMin) { sizeMin = e[0]; sizeVid = e[1]; }
          });
        }

        var priceCents = null, vid = null;
        if (chosenColor) {
          var ce = map.c[chosenColor];
          vid = ce[0];
          priceCents = ce[1];
          if (sizeMin !== null) priceCents = Math.max(priceCents, sizeMin);
          if (img && ce[2]) { img.src = ce[2]; img.removeAttribute('srcset'); }
        } else {
          if (img && card.__khOrig.src) {
            img.src = card.__khOrig.src;
            if (card.__khOrig.srcset) img.setAttribute('srcset', card.__khOrig.srcset);
          }
          if (sizeMin !== null) { priceCents = sizeMin; vid = sizeVid; }
        }
        if (vid) {
          a.setAttribute('href', card.__khOrig.href.split('?')[0] + '?variant=' + vid);
        } else if (card.__khOrig.href) {
          a.setAttribute('href', card.__khOrig.href);
        }
        if (priceEl) {
          priceEl.textContent = priceCents !== null ? formatEuro(priceCents) : card.__khOrig.price;
        }
      });
    }

    function apply() {
      var visible = 0;
      cards.forEach(function (card) {
        var ok = matches(card);
        card.classList.toggle('kh-product-hidden', !ok);
        if (ok) visible++;
      });
      if (countEl) countEl.textContent = visible + ' von ' + totalCount + ' Produkten';
      if (emptyEl) emptyEl.style.display = visible === 0 ? '' : 'none';
      updateCardPreviews();
      renderChips();
      var activeCount = state.types.length + state.colors.length + state.sizes.length + state.heights.length + (state.price ? 1 : 0);
      qsa('[data-kh-filter-count]').forEach(function (el) {
        el.textContent = activeCount > 0 ? ' (' + activeCount + ')' : '';
      });
      var resetBtns = qsa('[data-kh-reset]', root);
      resetBtns.forEach(function (b) { b.style.display = activeCount > 0 ? '' : 'none'; });
      updateAvailability();
    }

    function renderChips() {
      if (!chipsWrap) return;
      chipsWrap.innerHTML = '';
      var mk = function (label, kind, value) {
        var chip = document.createElement('span');
        chip.className = 'kh-chip';
        chip.textContent = label;
        var x = document.createElement('button');
        x.type = 'button';
        x.setAttribute('aria-label', label + ' entfernen');
        x.innerHTML = '<svg class="kh-icon" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="5" y1="5" x2="19" y2="19"/><line x1="19" y1="5" x2="5" y2="19"/></svg>';
        x.addEventListener('click', function () { toggle(kind, value, false); syncInputs(); apply(); });
        chip.appendChild(x);
        chipsWrap.appendChild(chip);
      };
      state.types.forEach(function (t) { mk(t, 'type', t); });
      state.colors.forEach(function (c) { mk(c, 'color', c); });
      state.sizes.forEach(function (s) { mk(labelFor('size', s), 'size', s); });
      state.heights.forEach(function (h) { mk('Höhe ' + h + ' cm', 'height', h); });
      if (state.price) mk(labelFor('price', state.price), 'price', state.price);
      chipsWrap.style.display = chipsWrap.children.length ? '' : 'none';
    }

    function toggle(kind, value, forceOn) {
      if (kind === 'type' || kind === 'color' || kind === 'size' || kind === 'height') {
        var arr = state[kind + 's'];
        var i = arr.indexOf(value);
        var on = forceOn !== undefined ? forceOn : i === -1;
        if (on && i === -1) arr.push(value);
        if (!on && i !== -1) arr.splice(i, 1);
      } else if (kind === 'price') {
        state.price = (forceOn === false || state.price === value) && forceOn !== true ? null : value;
      }
    }

    function syncInputs() {
      qsa('[data-kh-ftype]', document).forEach(function (input) {
        input.checked = state.types.indexOf(input.value) !== -1;
      });
      qsa('[data-kh-fcolor]', document).forEach(function (btn) {
        btn.classList.toggle('is-active', state.colors.indexOf(btn.getAttribute('data-value')) !== -1);
      });
      qsa('[data-kh-fsize]', document).forEach(function (btn) {
        btn.classList.toggle('is-active', state.sizes.indexOf(btn.getAttribute('data-value')) !== -1);
      });
      qsa('[data-kh-fheight]', document).forEach(function (btn) {
        btn.classList.toggle('is-active', state.heights.indexOf(btn.getAttribute('data-value')) !== -1);
      });
      qsa('[data-kh-fprice]', document).forEach(function (input) {
        input.checked = state.price === input.value || (input.value === '' && !state.price);
      });
    }

    document.addEventListener('change', function (e) {
      if (e.target.matches('[data-kh-ftype]')) { toggle('type', e.target.value, e.target.checked); apply(); }
      if (e.target.matches('[data-kh-fprice]')) { state.price = e.target.value || null; syncInputs(); apply(); }
    });
    document.addEventListener('click', function (e) {
      var cbtn = e.target.closest('[data-kh-fcolor]');
      if (cbtn) { toggle('color', cbtn.getAttribute('data-value')); syncInputs(); apply(); }
      var sbtn = e.target.closest('[data-kh-fsize]');
      if (sbtn) { toggle('size', sbtn.getAttribute('data-value')); syncInputs(); apply(); }
      var hbtn = e.target.closest('[data-kh-fheight]');
      if (hbtn) { toggle('height', hbtn.getAttribute('data-value')); syncInputs(); apply(); }
      var rbtn = e.target.closest('[data-kh-reset]');
      if (rbtn) {
        state.types = []; state.colors = []; state.sizes = []; state.heights = []; state.price = null;
        syncInputs(); apply();
      }
    });

    sortColorSwatches();

    var sortSelects = qsa('[data-kh-sort]');
    function sortCards(mode) {
      var wrappers = qsa('[data-kh-item]', grid);
      var sorted = wrappers.slice().sort(function (a, b) {
        if (mode === 'price-asc') return (+a.getAttribute('data-price')) - (+b.getAttribute('data-price'));
        if (mode === 'price-desc') return (+b.getAttribute('data-price')) - (+a.getAttribute('data-price'));
        if (mode === 'neu') return (+b.getAttribute('data-neu')) - (+a.getAttribute('data-neu')) || (+a.getAttribute('data-index')) - (+b.getAttribute('data-index'));
        return (+a.getAttribute('data-index')) - (+b.getAttribute('data-index'));
      });
      sorted.forEach(function (n) { grid.appendChild(n); });
    }
    sortSelects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        sortSelects.forEach(function (o) { o.value = sel.value; });
        sortCards(sel.value);
      });
    });

    var sheet = qs('#KhFilterSheet');
    if (sheet) {
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-kh-open-filter]')) { sheet.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }
        if (e.target.closest('[data-kh-close-filter]') || (e.target.classList && e.target.classList.contains('kh-fsheet__overlay'))) {
          sheet.classList.remove('is-open'); document.documentElement.style.overflow = '';
        }
      });
    }

    // Breiten-Buttons dynamisch aus den Karten aufbauen. Wenige verschiedene Werte
    // ergeben Einzelbuttons, viele Werte drei Bereiche an gerundeten Dritteln.
    var allWidths = {};
    cards.forEach(function (card) {
      (card.getAttribute('data-widths') || '').split(',').map(Number).filter(Boolean).forEach(function (w) { allWidths[w] = true; });
    });
    var wVals = Object.keys(allWidths).map(Number).sort(function (a, b) { return a - b; });
    if (wVals.length > 1) {
      var round10 = function (n) { return Math.round(n / 10) * 10; };
      var buckets = [];
      if (wVals.length <= 6) {
        wVals.forEach(function (w) { buckets.push({ key: 's' + w + '-' + (w + 1), label: w + ' cm' }); });
      } else {
        var t1 = round10(wVals[Math.floor(wVals.length / 3)]);
        var t2 = round10(wVals[Math.floor(wVals.length * 2 / 3)]);
        if (t2 <= t1) t2 = t1 + 10;
        buckets = [
          { key: 's0-' + t1, label: 'bis ' + t1 + ' cm' },
          { key: 's' + t1 + '-' + t2, label: t1 + ' bis ' + t2 + ' cm' },
          { key: 's' + t2 + '-', label: 'ab ' + t2 + ' cm' }
        ];
      }
      qsa('[data-kh-fsizes]').forEach(function (wrap) {
        buckets.forEach(function (b) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'kh-fsize';
          btn.setAttribute('data-kh-fsize', '');
          btn.setAttribute('data-value', b.key);
          btn.textContent = b.label;
          wrap.appendChild(btn);
        });
        var grp = wrap.closest('[data-kh-sgroup]');
        if (grp) grp.hidden = false;
      });
    }

    // Hoehen-Buttons dynamisch aus den Karten aufbauen
    var allHeights = {};
    cards.forEach(function (card) {
      (card.getAttribute('data-heights') || '').split(',').map(Number).filter(Boolean).forEach(function (h) { allHeights[h] = true; });
    });
    var hVals = Object.keys(allHeights).map(Number).sort(function (a, b) { return a - b; });
    if (hVals.length > 1) {
      qsa('[data-kh-fheights]').forEach(function (wrap) {
        hVals.forEach(function (h) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'kh-fsize';
          b.setAttribute('data-kh-fheight', '');
          b.setAttribute('data-value', String(h));
          b.textContent = h + ' cm';
          wrap.appendChild(b);
        });
        var grp = wrap.closest('[data-kh-hgroup]');
        if (grp) grp.hidden = false;
      });
    }

    apply();
  }

  /* ---------- Trusted Shops Live-Badges ---------- */
  function initTsBadges() {
    var els = qsa('[data-kh-ts]');
    if (!els.length) return;
    var CH = 'chl-c8800d58-1c9b-4c27-b3ba-b500d151e2b7';
    function fmtNum(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
    function apply(d) {
      els.forEach(function (el) {
        var fill = el.querySelector('[data-kh-ts-fill]');
        if (fill) fill.style.width = (d.r / 5 * 100) + '%';
        var num = el.querySelector('[data-kh-ts-num]');
        if (num) num.textContent = d.r.toFixed(1).replace('.', ',') + ' / 5';
        var cnt = el.querySelector('[data-kh-ts-count]');
        if (cnt) cnt.textContent = fmtNum(d.c) + ' Bewertungen';
        el.hidden = false;
      });
    }
    var cached = null;
    try { cached = JSON.parse(sessionStorage.getItem('khTsGrade') || 'null'); } catch (e) {}
    if (cached && cached.r) { apply(cached); return; }
    fetch('https://integrations.etrusted.com/feeds/grades/v1/channels/' + CH + '/touchpoints/all/feed.json')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var g = j && j.grades && (j.grades.overall || j.grades['365days']);
        if (!g || !g.rating) return;
        var d = { r: g.rating, c: g.count || 0 };
        try { sessionStorage.setItem('khTsGrade', JSON.stringify(d)); } catch (e) {}
        apply(d);
      }).catch(function () {});
  }
  initTsBadges();

  /* ---------- Cross-Selling via Shopify Recommendations ---------- */
  function initRecommendations() {
    var holder = qs('[data-kh-recommendations]');
    if (!holder) return;
    var url = holder.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var tmp = document.createElement('div');
        tmp.innerHTML = text;
        var inner = tmp.querySelector('[data-kh-recommendations]');
        if (inner && inner.innerHTML.trim().length) {
          holder.innerHTML = inner.innerHTML;
        } else {
          var section = holder.closest('.shopify-section');
          if (section) section.style.display = 'none';
        }
      })
      .catch(function () {});
  }

  /* ---------- PDP: Montageanleitung direkt im Modal öffnen (D6b) ---------- */
  function initPdpMontage() {
    var teaser = qs('.kh-pdp-montage[data-kh-anleitung]');
    if (!teaser || !qs('[data-kh-pdp]')) return;
    var state = 'idle';
    teaser.addEventListener('click', function (e) {
      if (state === 'ready') return; /* kh-montage.js übernimmt ab jetzt */
      e.preventDefault();
      if (state === 'loading') return;
      state = 'loading';
      fetch('/pages/montageanleitungen')
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var modal = doc.getElementById('KhMontageModal');
          if (!modal) throw new Error('kein Modal');
          var cssHref = null, jsSrc = null;
          doc.querySelectorAll('link[rel="stylesheet"]').forEach(function (l) {
            if ((l.getAttribute('href') || '').indexOf('kh-montage') >= 0) cssHref = l.getAttribute('href');
          });
          doc.querySelectorAll('script[src]').forEach(function (s) {
            if ((s.getAttribute('src') || '').indexOf('kh-montage') >= 0) jsSrc = s.getAttribute('src');
          });
          if (!jsSrc) throw new Error('kein montage-js');
          document.body.appendChild(document.importNode(modal, true));
          function loadScript() {
            var script = document.createElement('script');
            script.src = jsSrc;
            script.onload = function () { state = 'ready'; teaser.click(); };
            script.onerror = function () { window.location.href = teaser.getAttribute('href'); };
            document.body.appendChild(script);
          }
          if (cssHref) {
            var link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = cssHref;
            link.onload = loadScript;
            link.onerror = loadScript;
            document.head.appendChild(link);
          } else {
            loadScript();
          }
        })
        .catch(function () { window.location.href = teaser.getAttribute('href'); });
    });
  }

  /* ---------- Init ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    Drawer.init();
    initAtcForms();
    initSteppers();
    initHeader();
    initTabs();
    initAccordions();
    initPdp();
    initPdpMontage();
    initCollection();
    initRecommendations();
  });

  window.KhCartDrawer = Drawer;
})();

/* Tabs-Scroll-Affordance: Fade rechts, solange weitere Reiter verdeckt sind */
(function () {
  'use strict';
  function refresh(w, l) {
    var more = l.scrollWidth - l.clientWidth - l.scrollLeft > 8;
    w.classList.toggle('kh-tabscroll', more);
  }
  function init() {
    var wraps = document.querySelectorAll('[data-kh-tabs]');
    for (var i = 0; i < wraps.length; i++) {
      (function (w) {
        var l = w.querySelector('.kh-tabs__list');
        if (!l) return;
        refresh(w, l);
        l.addEventListener('scroll', function () { refresh(w, l); }, { passive: true });
        window.addEventListener('resize', function () { refresh(w, l); });
      })(wraps[i]);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
